import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import style from './index.module.scss';
import clsx from 'clsx';

const FeaturedPostTile = ({ link, thumbnail, title, isFirst, isMiddle, isLast, isVisible = true, isMobile }) => {
    return (
        <motion.div
            initial={{ opacity: !isMobile ? 0 : 1, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: isLast ? 0.4 : !isMiddle && !isMobile && 0.8, y: { duration: 0.8 } }}
            className={clsx(style.tileContainer, isMiddle && style.bigOne)}
        >
            <a href={link} className={style.imageContainer}>
                <LazyLoadImage effect={'opacity'} src={thumbnail} alt={title} className={style.image} />
                <p className={style.text}>Lire</p>
            </a>
            <div className={clsx(style.info, !isVisible && style.hide)}>
                <p className={style.title}>{title}</p>
                <a href={link} className={style.link}>
                    Voir plus
                </a>
            </div>
            {isFirst && (
                <motion.p
                    initial={{ opacity: 0, scale: 0 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 1.2, scale: { duration: 0.5 } }}
                    className={style.pinNew}
                >
                    Nouveau
                </motion.p>
            )}
        </motion.div>
    );
};

export default FeaturedPostTile;
